import api from "PFCore/api";
import { Collection, CustomValue, Id } from "PFCore/types";

export type FetchRareSkillsParams = {
  profileId: Id;
  maxNumberOfSkills?: number;
};
export type FetchRareSkillsResponse = Collection<CustomValue[]>;

export const fetchRareSkills = (params: FetchRareSkillsParams) =>
  api<FetchRareSkillsResponse>({
    url: "profile_rare_skills",
    params
  });
